// extracted by mini-css-extract-plugin
export default {"article":"article-block_article__L4ra-","title":"article-block_title__SU19C","text":"article-block_text__sY3dr","image":"article-block_image__DcMUA"};